/* eslint-disable node/callback-return */
/**
 * Redux Performance Monitoring Middleware
 *
 * Lightweight middleware to detect Redux action storms that might indicate
 * performance issues or update loops.
 */

import { createActionMonitor } from "./performanceMonitor";

// Create our action monitor for Redux
const reduxMonitor = createActionMonitor("redux");

/**
 * Redux middleware for performance monitoring
 * Detects action frequency problems without affecting normal Redux flow
 */
function performanceMonitorMiddleware(store: any) {
  return function (next: any) {
    return function (action: any) {
      // Pass the action through immediately (don't block or delay)
      const result = next(action);

      // Monitor the action after it's been processed (don't affect timing)
      if (typeof action.type === "string") {
        // Only monitor actual actions with string types
        reduxMonitor(action.type);
      }

      // Return the result from next middleware
      return result;
    };
  };
}

export default performanceMonitorMiddleware;
